import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-198c2861"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-content" }
const _hoisted_2 = { class: "head-content" }
const _hoisted_3 = { class: "part-left" }
const _hoisted_4 = { class: "main-info" }
const _hoisted_5 = { class: "other-info" }
const _hoisted_6 = { class: "info-list" }
const _hoisted_7 = { class: "info-item" }
const _hoisted_8 = { class: "label" }
const _hoisted_9 = { class: "info-content" }
const _hoisted_10 = { class: "info-item" }
const _hoisted_11 = { class: "label" }
const _hoisted_12 = { class: "info-content" }
const _hoisted_13 = { class: "info-item" }
const _hoisted_14 = { class: "label" }
const _hoisted_15 = { class: "info-content" }
const _hoisted_16 = { class: "part-right" }
const _hoisted_17 = { class: "main-info" }
const _hoisted_18 = { class: "other-info" }

import { computed, nextTick, PropType, ref, Ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import LastRemoverTab
  from '@/views/dashboard/safe-status/loaris-trojan-remover/_components/remover-details/last-remover-tab.vue'
import TerminalHead from '@/views/dashboard/group/client/terminal-info/terminal-head/terminal-head.vue'
import HandleArea
  from '@/views/dashboard/safe-status/loaris-trojan-remover/_components/remover-details/HandleArea.vue'
import VirusView from '@/views/dashboard/notice-manage/virus-notification-log/_components/virus-view/virus-view.vue'
import { TrojanItem } from '@/views/dashboard/safe-status/loaris-trojan-remover/loaris-trojan-remover.service'
import { formatTimeStamp } from '@/utils/time'

enum TabName {
  lastRemoverTab = 'lastRemoverTab',
  trustArea = 'TrustArea',
  quarantineTab = 'quarantineTab',
  removerLogTab = 'removerLogTab',
}

type Refreshable = { refresh?: () => unknown }


export default /*#__PURE__*/_defineComponent({
  __name: 'remover-details',
  props: {
  modelValue: {
    type: Boolean,
    default: false,
  },
  trojanInfo: {
    type: Object as PropType<TrojanItem>,
    default: () => ({}),
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const { t, locale } = useI18n()

const drawerTitle = computed(() => {
  void locale.value
  return t('loarisTrojanRemover.removerDetailsTitle', {
    name: props.trojanInfo?.computer_name || '—',
  })
})

const scanTypeLabelI18n = computed<Record<number, string>>(() => {
  void locale.value
  return {
    1: t('safeProtectionModule.lightningScan'),
    2: t('safeProtectionModule.fullDiskScan'),
    3: t('safeProtectionModule.scanTypeDefense'),
    4: t('safeProtectionModule.scanTypeCustom'),
  }
})

const loginStatusLabelI18n = computed<Record<number, string>>(() => {
  void locale.value
  return {
    1: t('groupClient.online'),
    2: t('groupClient.offline'),
    4: t('loarisTrojanRemover.loginStatusQuit'),
  }
})

const activeTab = ref<TabName>(TabName.lastRemoverTab)
const tabCount = ref<Record<TabName, number>>({
  [TabName.lastRemoverTab]: 0,
  [TabName.removerLogTab]: 0,
  [TabName.trustArea]: 0,
  [TabName.quarantineTab]: 0,
})

const lastRemoverTabRef = ref<Refreshable | null>(null)
const trustAreaRef = ref<Refreshable | null>(null)
const quarantineAreaRef = ref<Refreshable | null>(null)
const removerLogTabRef = ref<Refreshable | null>(null)

/** 每个 tab 对应的列表组件：切 tab 时统一调用其 refresh() 重拉数据 */
const tabRefreshMap: Record<TabName, Ref<Refreshable | null>> = {
  [TabName.lastRemoverTab]: lastRemoverTabRef,
  [TabName.trustArea]: trustAreaRef,
  [TabName.quarantineTab]: quarantineAreaRef,
  [TabName.removerLogTab]: removerLogTabRef,
}

function updateTabCount (name: TabName, value: unknown) {
  tabCount.value[name] = Number(value || 0)
}

function onVirusViewChangeTotal (p: { total: number; tabKey: string }) {
  if (p.tabKey === TabName.removerLogTab) {
    updateTabCount(TabName.removerLogTab, p.total)
  }
}

function handleClose () {
  emit('update:modelValue', false)
}

/** 重开抽屉时复位 activeTab 期间跳过刷新：子组件重挂载会自行拉取，避免双重请求 */
let suppressTabRefresh = false
watch(activeTab, (name) => {
  if (suppressTabRefresh) return
  void nextTick(() => tabRefreshMap[name]?.value?.refresh?.())
})

watch(() => props.modelValue, (value) => {
  if (!value) return
  suppressTabRefresh = true
  activeTab.value = TabName.lastRemoverTab
  tabCount.value = {
    [TabName.lastRemoverTab]: 0,
    [TabName.removerLogTab]: 0,
    [TabName.trustArea]: 0,
    [TabName.quarantineTab]: 0,
  }
  void nextTick(() => {
    suppressTabRefresh = false
  })
})

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    title: drawerTitle.value,
    "model-value": __props.modelValue,
    "destroy-on-close": "",
    size: "80%",
    onClose: handleClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(TerminalHead, {
          system_type: __props.trojanInfo.system_type,
          "login-status": __props.trojanInfo.login_status
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(__props.trojanInfo.computer_name), 1),
                  _createElementVNode("div", _hoisted_5, _toDisplayString(__props.trojanInfo.system_name), 1)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('safeProtectionModule.lastScanTimeCol')), 1),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(formatTimeStamp)(__props.trojanInfo.last_scan_time, 'YYYY-MM-DD HH:mm')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('safeProtectionModule.lastScanType')), 1),
                    _createElementVNode("div", _hoisted_12, _toDisplayString(scanTypeLabelI18n.value[Number(__props.trojanInfo.scan_type)] ?? '—'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('groupClient.terminalStatus')), 1),
                    _createElementVNode("div", _hoisted_15, _toDisplayString(loginStatusLabelI18n.value[Number(__props.trojanInfo.login_status)] ?? '—'), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, _toDisplayString(__props.trojanInfo.user_mark), 1),
                _createElementVNode("div", _hoisted_18, _toDisplayString(__props.trojanInfo.group_name), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["system_type", "login-status"]),
        _createVNode(_component_el_tabs, {
          class: "tabs-wrap",
          modelValue: activeTab.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((activeTab).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('loarisTrojanRemover.tabUnhandledRisks', { n: tabCount.value[TabName.lastRemoverTab] }),
              name: TabName.lastRemoverTab
            }, {
              default: _withCtx(() => [
                _createVNode(LastRemoverTab, {
                  class: "cm-ui-mt15",
                  ref_key: "lastRemoverTabRef",
                  ref: lastRemoverTabRef,
                  "trojan-info": __props.trojanInfo,
                  onChangeCount: _cache[0] || (_cache[0] = ($event: any) => (updateTabCount(TabName.lastRemoverTab, $event)))
                }, null, 8, ["trojan-info"])
              ]),
              _: 1
            }, 8, ["label", "name"]),
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('loarisTrojanRemover.tabTrustZone', { n: tabCount.value[TabName.trustArea] }),
              name: TabName.trustArea
            }, {
              default: _withCtx(() => [
                _createVNode(HandleArea, {
                  ref_key: "trustAreaRef",
                  ref: trustAreaRef,
                  "process-type": 4,
                  device_id: __props.trojanInfo.device_id,
                  system_type: __props.trojanInfo.system_type,
                  onTotalChange: _cache[1] || (_cache[1] = ($event: any) => (updateTabCount(TabName.trustArea, $event)))
                }, null, 8, ["device_id", "system_type"])
              ]),
              _: 1
            }, 8, ["label", "name"]),
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('loarisTrojanRemover.tabQuarantine', { n: tabCount.value[TabName.quarantineTab] }),
              name: TabName.quarantineTab
            }, {
              default: _withCtx(() => [
                _createVNode(HandleArea, {
                  ref_key: "quarantineAreaRef",
                  ref: quarantineAreaRef,
                  "process-type": 2,
                  device_id: __props.trojanInfo.device_id,
                  system_type: __props.trojanInfo.system_type,
                  onTotalChange: _cache[2] || (_cache[2] = ($event: any) => (updateTabCount(TabName.quarantineTab, $event)))
                }, null, 8, ["device_id", "system_type"])
              ]),
              _: 1
            }, 8, ["label", "name"]),
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('loarisTrojanRemover.tabVirusScanLog', { n: tabCount.value[TabName.removerLogTab] }),
              name: TabName.removerLogTab
            }, {
              default: _withCtx(() => [
                _createVNode(VirusView, {
                  ref_key: "removerLogTabRef",
                  ref: removerLogTabRef,
                  device_id: __props.trojanInfo.device_id,
                  onChangeTotal: onVirusViewChangeTotal
                }, null, 8, ["device_id"])
              ]),
              _: 1
            }, 8, ["label", "name"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["title", "model-value"]))
}
}

})